/* Slide-out cart drawer. Content is rendered by sections/cart-drawer.liquid (Section Rendering API).
   Qty/remove/add-on clicks reuse the handlers in theme.js; this file only opens/closes and re-renders. */
(function () {
  'use strict';
  if (window.__cartDrawer) { return; }
  window.__cartDrawer = true;

  var D = document;
  var root = D.querySelector('[data-cd]');
  if (!root) { return; }
  var panel = D.querySelector('[data-cd-panel]');
  var T = window.theme || {};
  var routes = T.routes || {};
  var base = routes.root || '/';
  var html = D.documentElement;
  var lastFocus = null;
  var renderId = 0;
  var isOpen = false;

  function $$(s, c) { return Array.prototype.slice.call((c || D).querySelectorAll(s)); }
  function content() { return D.querySelector('[data-cd-root]'); }

  function render() {
    var id = ++renderId;
    return fetch(base + (base.indexOf('?') < 0 ? '?' : '&') + 'sections=cart-drawer&_=' + Date.now(), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (id !== renderId) { return; } /* a newer render is already on its way */
        var markup = data && data['cart-drawer'];
        if (!markup) { return; }
        var fresh = new DOMParser().parseFromString(markup, 'text/html').querySelector('[data-cd-root]');
        var old = content();
        if (!fresh || !old) { return; }
        var a = D.activeElement;
        var act = a && a.getAttribute && a.closest && panel.contains(a) ? { act: a.getAttribute('data-cd-act'), key: a.getAttribute('data-key') } : null;
        old.innerHTML = fresh.innerHTML;
        if (isOpen && act) {
          var again = act.act ? D.querySelector('[data-cd-root] [data-cd-act="' + act.act + '"][data-key="' + act.key + '"]') : null;
          var target = again || D.querySelector('[data-cd-root] [data-cd-close]') || panel;
          if (!panel.contains(D.activeElement) || D.activeElement === D.body) { target.focus(); }
        }
      })
      .catch(function () { /* keep the last good markup */ });
  }

  function focusables() {
    return $$('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])', panel)
      .filter(function (el) { return !el.hidden && !el.closest('[hidden]'); });
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') { return; }
    var f = focusables();
    if (!f.length) { e.preventDefault(); panel.focus(); return; }
    var first = f[0], last = f[f.length - 1], cur = D.activeElement;
    if (!panel.contains(cur)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && (cur === first || cur === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && cur === last) { e.preventDefault(); first.focus(); }
  }

  function open(trigger) {
    if (isOpen) { render(); return; }
    lastFocus = trigger || D.activeElement || null;
    isOpen = true;
    root.classList.add('is-open');
    html.classList.add('cd-lock');
    D.addEventListener('keydown', onKey);
    var x = D.querySelector('[data-cd-root] [data-cd-close]');
    (x || panel).focus();
    render();
  }

  function close() {
    if (!isOpen) { return; }
    isOpen = false;
    root.classList.remove('is-open');
    html.classList.remove('cd-lock');
    D.removeEventListener('keydown', onKey);
    var back = lastFocus;
    if (!back || !back.focus || !D.contains(back) || back.disabled) { back = D.querySelector('[data-cart-drawer-open]'); }
    if (back && back.focus) { back.focus(); }
  }

  window.cartDrawer = { open: open, close: close, render: render };

  /* arriving from the (disabled) cart page: open the drawer if there is something in the cart */
  var flag = null;
  try { flag = sessionStorage.getItem('jj_open_drawer'); sessionStorage.removeItem('jj_open_drawer'); } catch (e0) { flag = null; }
  if (flag) {
    fetch(routes.cartJs || '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && c.item_count > 0) { open(); } })
      .catch(function () { /* ignore */ });
  }

  /* header Cart link: always opens the drawer, never navigates to /cart */
  D.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-cart-drawer-open]') : null;
    if (t) {
      if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey ) { return; }
      e.preventDefault();
      open(t);
      return;
    }
    if (e.target.closest && e.target.closest('[data-cd-close]') && isOpen) { close(); }
  });

  /* add to cart: open instead of the inline message */
  D.addEventListener('cart:added', function (e) {
    e.preventDefault();
    open(e.detail && e.detail.trigger);
  });

  /* any cart change (qty, remove, add-on, guard clean-up): redraw while open */
  D.addEventListener('cart:updated', function () { if (isOpen) { render(); } });

  /* checkout: never let add-ons (protection / priority) go through alone.
     After the live-cart check we navigate straight to /checkout (GET). We never submit the form natively:
     it drops the clicked button's name=checkout, POST /cart then lands on the redirect-only cart page. */
  function goCheckout() { window.location.assign('/checkout'); }

  /* coming back from checkout via the browser Back button (bfcache) must not leave the button stuck on "Loading…" */
  window.addEventListener('pageshow', function (e) { if (e.persisted) { render(); } });

  D.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-cd-checkout]')) { return; }
    e.preventDefault();
    if (form.__busy) { return; }
    form.__busy = true;
    var btn = form.querySelector('[data-checkout]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = (T.strings && T.strings.loading) || 'Loading…'; }
    function release() {
      form.__busy = false;
      if (btn) { btn.disabled = false; btn.textContent = label; }
    }
    var tc = window.themeCart;
    if (!tc) { goCheckout(); return; }
    tc.getCart()
      .then(function (cart) { return tc.guard(cart); })
      .then(function (res) {
        tc.applyCart(res.cart);
        if (!tc.hasHandle(res.cart, T.mainHandle || 'kicking-santa-legs-hat')) { release(); render(); return; }
        goCheckout();
      })
      .catch(function () { goCheckout(); });
  });
})();
